import React, { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import { resendInvite } from "../redux/thunks/Auth";
import AlertBox from "../components/common/AlertBox";
import { getResource } from "../redux/thunks/Resource";
import { useDispatch, useSelector } from "react-redux";
import OnboardingBox from "../components/OnboardingBox";
import Button from "../components/sub-component/Button";
import { getAssessment } from "../redux/thunks/Assessment";
import { useHistory, useLocation } from "react-router-dom";
import ProcessingIndicator from "../components/common/ProcessingIndicator";
import { ReactComponent as TestFuseWatermarkIcon } from "../assets/icons/candidate-assessment/Watermark Light.svg";

function InviteLinkExpired() {
  const history = useHistory();
  const dispatch = useDispatch();
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  const assessId = searchParams.get("assess_id");
  const inviteId = searchParams.get("invite_id");
  const inviteToken = searchParams.get("invite_token");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

  const [icon, setIcon] = useState();
  const [alert, setAlert] = useState(null);
  const [isloading, setIsLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const assessment = useSelector((state) => state.assessmentReducer);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setProcessing(true);
      const response = await dispatch(
        resendInvite({
          invite_token: inviteToken,
          assess_id: assessId,
          invite_id: inviteId,
        })
      );
      setProcessing(false);
      setAlert(
        <AlertBox
          description="Invite send successfully!"
          color="success"
          title="Success"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />
      );
    } catch (error) {
      setProcessing(false);
      setAlert(
        <AlertBox
          description={`Error occurred: ${error.message}`}
          color="danger"
          title="Error"
          onCloseAlert={() => {
            setAlert(null);
          }}
        />
      );
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
      dispatch(getAssessment({ id: assessId }));
    }, 4000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    (async () => {
      if (assessment?.current_assessment?.tenant?.image_id) {
        const imageResult = await dispatch(
          getResource({ id: assessment?.current_assessment?.tenant?.image_id })
        );
        if (!imageResult.error) {
          setIcon(imageResult.payload.url);
        }
      }
    })();
  }, [assessment?.current_assessment?.tenant?.image_id]);

  return (
    <>
      {alert}
      {isloading || assessment?.loading_current_assess ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProcessingIndicator />
        </div>
      ) : (
        <div className="candidate-invite-main-container">
          <div className="candidate-invite-container">
            {assessment?.current_assessment?.tenant && (
              <div className="assessment-header">
                {icon ? (
                  <img className="assessment-header-icon" src={icon} alt="" />
                ) : (
                  <div className="assessment-header-icon-initial">
                    <span className="body-1 white">
                      {(
                        assessment?.current_assessment?.tenant?.company_name?.slice(
                          0,
                          2
                        ) || ""
                      ).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="headline-1 dark-100">
                  {assessment?.current_assessment?.tenant?.company_name}
                </span>
              </div>
            )}
            <span className="headline-3 text-start">
              Invitation Link Expired
            </span>
            <span className="body-2 dark-50 text-start">
              {`Oops! It seems like the invitation link has expired. Don't
                worry, we can send you a new one. Just click the button below to
                receive another invitation.`}
            </span>
            <form className="w-100" onSubmit={handleSubmit}>
              <Button
                btn="ragular-btn"
                varrient="primary"
                textClass="body-1"
                processing={processing}
                type={"submit"}
                title={"Resend Link"}
                style={{ width: "100%", height: "40px" }}
              />
            </form>
          </div>
          <div className="watermark mt-3">
            <TestFuseWatermarkIcon style={{ height: "50px" }} />
          </div>
        </div>
      )}
    </>
  );
}

export default InviteLinkExpired;
